import { AssetClass } from "../store/types";
import { createSelector } from "@reduxjs/toolkit";
import { tenantModulesSelector } from "hooks/use-tenant-settings";
export const filterAvailableAnalysesByAssetClass = (analyses, entityAssetClasses) => {
    if (!analyses || !entityAssetClasses || entityAssetClasses.length === 0) {
        return analyses;
    }
    if (entityAssetClasses.length === 1) {
        return analyses.filter((x) => x.applicableAssetClasses && (entityAssetClasses.some((e) => x.applicableAssetClasses?.includes(e)) ||
            x.applicableAssetClasses?.includes(AssetClass.ALL) || x.applicableAssetClass === AssetClass.ALL));
    }
    return analyses.filter((x) => (!x.applicableAssetClasses?.length || x.applicableAssetClasses.includes(AssetClass.ALL) ||
        entityAssetClasses.some((e) => x.applicableAssetClasses?.includes(e))) && (x.hideWhenMultipleAssetClasses === undefined || x.hideWhenMultipleAssetClasses === false));
};
export const filterAnalysesByAvailableModules = (state, analyses) => {
    const modules = tenantModulesSelector(state);
    return analyses?.map((x) => ({
        ...x,
        sections: x.sections?.filter((se) => {
            const customOrDefaultSection = se.requiredModules?.length ? se.requiredModules : state.entities.Section[se.id || ""]?.requiredModules;
            if (!customOrDefaultSection || customOrDefaultSection?.length === 0) {
                return true;
            }
            return customOrDefaultSection?.every((module) => modules.includes(module));
        })
    }))?.filter((x) => x.sections && x.sections.length > 0);
};
/*
 * Factory to create a memoized selector bound to a specific analyses array reference.
 * It only recomputes when tenant modules or sections slice change (or when the analyses reference changes, when recreated).
 */
export const makeFilterAnalysesByAvailableModulesSelector = (analyses) => createSelector([tenantModulesSelector, (state) => state.entities.Section], (modules, sections) => analyses?.map((x) => ({
    ...x,
    sections: x.sections?.filter((se) => {
        const customOrDefaultSection = se.requiredModules?.length ? se.requiredModules : sections[se.id || ""]?.requiredModules;
        if (!customOrDefaultSection || customOrDefaultSection?.length === 0) {
            return true;
        }
        return customOrDefaultSection?.every((module) => modules.includes(module));
    })
}))?.filter((x) => x.sections && x.sections.length > 0));
